export function cc(
  s: string,
  ...classes: (string | false | null | undefined)[]
): string {
  return [s, ...classes.filter(Boolean)].join(" ");
}

export function formatNumberValue(value: string): string {
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  const formatted = num.toFixed(2);
  // Swap the ASCII hyphen for the proper minus sign (U+2212) —
  // most fonts draw the hyphen centered on x-height (for use between words),
  // which reads as vertically misaligned next to digits.
  return formatted.startsWith("-") ? `−${formatted.slice(1)}` : formatted;
}
